import { render, staticRenderFns } from "./sync-history.vue?vue&type=template&id=2c47c400&scoped=true&"
import script from "./sync-history.vue?vue&type=script&lang=js&"
export * from "./sync-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47c400",
  null
  
)

export default component.exports